var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { createSdk } from '@lucidlink/sdk';
import { createMemKvStorage } from '@lucidlink/sdk/kv-storage';
import { getRootLogger } from '@lucidlink/tscore';
import { DEPENDENCY_KEYS, useDependency, useLucidSdk, } from '@lucidlink/workspacemanagement';
export const ExposeLucidSdk = () => {
    _react_refresh_temp_2();
    const { lucidSdk } = useLucidSdk();
    const webserviceUrl = useDependency(DEPENDENCY_KEYS.WEB_SERVICE_ENDPOINT);
    const additionalInfo = useDependency(DEPENDENCY_KEYS.GetAdditionalInfo)();
    window.lucidSdk = lucidSdk;
    window.createInMemoryLucidSdk = async () => createSdk({
        baseUrl: webserviceUrl,
        logger: getRootLogger(),
        additionalInfo,
        kvStorage: await createMemKvStorage(),
    });
    return _jsx(_Fragment, {});
};
_react_refresh_temp_1 = ExposeLucidSdk;
$RefreshReg$(_react_refresh_temp_1, "ExposeLucidSdk");
_react_refresh_temp_2(ExposeLucidSdk, "MK5aifGMpZnAKyU2v+SzzEqvJsY=", false, () => [useLucidSdk, useDependency, useDependency]);
